import React from 'react';

import './nav.css'

import NavItem from './navItem/navItem'

import { useState  } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'


function Nav(props){

    const [navOpen, setNav] = useState("closed")

    function toggleMenu(){
        console.log("toggling menu")
        if(navOpen === "closed")
            setNav("open")
        else{
            setNav("closed")
        }
    }

    return (
        <div className="nav--container">
            <div className="nav--desktop">
                {
                    props.children ? 
                    props.children.map(item => <NavItem>{item}</NavItem>) :
                    <p>Nav Coming Soon</p>
                }
            </div>
            <div className="nav--mobile">
                    
                    <button className="hamburger--button">
                        <FontAwesomeIcon icon={faBars} onClick={() => { toggleMenu()}}/>
                    </button>
                    <div className={"mobile--nav--container " + navOpen}>
                        <button className="close--button">
                            <FontAwesomeIcon icon={faTimes} onClick={() => { toggleMenu()}} /> 
                        </button>
                        {
                            props.children ? 
                            props.children.map(item => <NavItem>{item}</NavItem>) :
                            <p>Nav Coming Soon</p>
                        }
                    </div>  
                    
            </div>
        </div> 
      );
}


export default Nav;